/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { css } from 'styled-components'

export const StyledBoxVector = styled.div`
  margin: 0 auto;
  width: 45vw;
`

const deptNode = (lgth: any) => {
  const base = 8
  return {
    current: base * lgth,
    childs: base * (lgth + 1),
  }
}

const anchorCss = (x: any) => {
  let anchors = ''
  for (let i = 0; i < x; i += 1) {
    anchors += `a:nth-child(${i + 2}) p {
        padding-left: calc(${i + 1} * var(--category_navegation_padding));
      }`
  }
  return css`
    ${anchors}
  `
}

export const StyledCategoryDisplay = styled.div<any>`
  margin-top: var(--spacing-margin-small);
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  .breadcrumbs-container {
    padding-bottom: 16px;
    border-bottom: 1px solid #dedede;
    width: 100%;
    .ant-breadcrumb {
      margin: 0;
    }
  }
  .banners-container {
    margin-top: 16px;
    &.banners-ads {
      .adBox {
        height: auto;
      }
    }
  }
  .breadcrumbs {
    grid-area: crumbs;
    height: 65px;
  }
  .grid-content {
    display: grid;
    gap: 0 8px;
    grid-template-columns: 320px 1fr;
  }
  .banners {
    grid-area: ${(props) => (props.bannersLength ? 'banner' : '')};
  }
  .lateral_navegation {
    grid-area: nav;
    width: 300px;
  }
  .products {
    grid-area: products;
  }

  .category_navegation {
    padding-top: var(--spacing-padding-medium);
    padding-right: var(--spacing-padding-large);

    ul {
      margin-top: var(--spacing-margin-xSmall);
      padding-left: var(--spacing-padding-medium);
      line-height: 15px;
      line-break: auto;
      overflow-wrap: break-word;
      a p {
        margin: var(--spacing-margin-xSmall) 0;
      }
    }
    .category_navegation__parents {
      padding: 0;
      margin: 0;
      --category_navegation_padding: 8px;
      ${(props) => anchorCss(props.parentLinksLength)};
    }
    .category_navegation__current {
      padding-left: ${(props) => deptNode(props.parentLinksLength).current}px;
    }
    .category_navegation__childs {
      padding-left: ${(props) => deptNode(props.parentLinksLength).childs}px;
    }
  }
  .category_breadcrumbs {
    &.ant-breadcrumb > span:last-child a {
      color: var(--color-black);
    }
  }
  .category_breadcrumbs .ant-breadcrumb-link a:hover {
    color: var(--color-black);
  }
  .category_products-empty {
    svg {
      width: 500px;
    }
  }
  .banner__container {
    max-width: 100%;
  }
  @media screen and (max-width: 576px) {
    grid-template-areas: 'nav banner' 'nav products';
    grid-template-columns: 1px auto;
    grid-template-rows: 1fr;
    gap: 0 0;
    .category_products-empty {
      width: 100%;
      svg {
        width: 100%;
      }
    }
    .lateral_navegation {
      width: 1px;
    }

    .breadcrumbs {
      display: none;
    }
    .grid-content {
      display: unset;
    }
    .banners {
      display: ${(props) => (props.bannersLength ? '' : 'none')};
      padding-top: 20px;
      max-width: 94vw;
    }
  }
  @media screen and (max-width: 768px) {
    .category_navegation {
      min-width: 150px;
    }
  }
`

export const ProductsHeaderStyles = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin: var(--spacing-margin-small) 0px;

  .products-length {
    color: #9d9d9d;
    font-size: var(--typography-size-s3);
    padding-left: var(--spacing-padding-medium);
  }
`

export const ProductsContainer = styled.div`
  margin-top: var(--spacing-margin-small);
`
